import { ImageProps } from "../types";

export const PngIcon = ({ src, width, height }: ImageProps) => (
  <img src={`/img/png/${src}`} alt={src} width={width} height={height} />
);
